import apiClient from './api';
import { Notification, NotificationChannelConfig, ApiResponse } from '@/types';

class NotificationsService {
  async getNotifications(limit = 50, offset = 0): Promise<Notification[]> {
    const response = await apiClient.get<ApiResponse<Notification[]>>(`/notifications?limit=${limit}&offset=${offset}`);
    return response.data.data || [];
  }

  async getUnreadCount(): Promise<number> {
    const response = await apiClient.get<ApiResponse<{ count: number }>>('/notifications/unread-count');
    return response.data.data?.count || 0;
  }

  async markAsRead(id: string): Promise<void> {
    await apiClient.patch(`/notifications/${id}/read`);
  }

  async markAllAsRead(): Promise<void> {
    await apiClient.post('/notifications/read-all');
  }

  // Notification Channels (settings)
  async getChannels(): Promise<NotificationChannelConfig[]> {
    const response = await apiClient.get<ApiResponse<NotificationChannelConfig[]>>('/settings/notification-channels');
    return response.data.data || [];
  }

  async createChannel(data: { name: string; type: string; config: Record<string, unknown>; is_enabled?: boolean }): Promise<NotificationChannelConfig> {
    const response = await apiClient.post<ApiResponse<NotificationChannelConfig>>('/settings/notification-channels', data);
    return response.data.data!;
  }

  async updateChannel(id: string, data: Partial<{ name: string; type: string; config: Record<string, unknown>; is_enabled: boolean }>): Promise<NotificationChannelConfig> {
    const response = await apiClient.put<ApiResponse<NotificationChannelConfig>>(`/settings/notification-channels/${id}`, data);
    return response.data.data!;
  }

  async deleteChannel(id: string): Promise<void> {
    await apiClient.delete(`/settings/notification-channels/${id}`);
  }

  async testChannel(id: string): Promise<void> {
    await apiClient.post(`/settings/notification-channels/${id}/test`);
  }
}

export const notificationsService = new NotificationsService();
